import React, { useState } from 'react';
import { Impressum } from './Impressum';
interface LoginProps {
  onLogin: (username: string, password: string) => void;
  loginError: string | null;
}
export function Login({
  onLogin,
  loginError
}: LoginProps) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showImpressum, setShowImpressum] = useState(false);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Simulate network request
    setTimeout(() => {
      onLogin(username, password);
      setIsLoading(false);
    }, 800);
  };
  return <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex flex-col justify-center items-center p-6" data-id="element-522">
      <div className="w-full max-w-md" data-id="element-523">
        <div className="text-center mb-8" data-id="element-524">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sip3wjubm1WrwbdT27XCT7/logo_%283%29.svg" alt="UNIQFOOD Logo" className="h-16 mx-auto mb-6" data-id="element-525" />
          <h1 className="text-2xl font-bold text-gray-800" data-id="element-526">
            Produktionssteuerungssystem
          </h1>
          <p className="text-gray-600 mt-2" data-id="element-527">
            Bitte melden Sie sich an, um fortzufahren
          </p>
        </div>
        <div className="bg-white rounded-xl shadow-md p-8 border border-gray-100" data-id="element-528">
          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-529">
            {loginError && <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded-md" data-id="element-530">
                <div className="flex" data-id="element-531">
                  <div className="flex-shrink-0" data-id="element-532">
                    <svg className="h-5 w-5 text-red-500" viewBox="0 0 20 20" fill="currentColor" data-id="element-533">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" data-id="element-534" />
                    </svg>
                  </div>
                  <div className="ml-3" data-id="element-535">
                    <p className="text-sm text-red-700" data-id="element-536">{loginError}</p>
                  </div>
                </div>
              </div>}
            <div data-id="element-537">
              <label htmlFor="username" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-538">
                Benutzername
              </label>
              <input id="username" name="username" type="text" required value={username} onChange={e => setUsername(e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-[#8DC63F] focus:border-[#8DC63F]" placeholder="Benutzername eingeben" data-id="element-539" />
            </div>
            <div data-id="element-540">
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-541">
                Passwort
              </label>
              <input id="password" name="password" type="password" required value={password} onChange={e => setPassword(e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-[#8DC63F] focus:border-[#8DC63F]" placeholder="Passwort eingeben" data-id="element-542" />
            </div>
            <div data-id="element-543">
              <button type="submit" disabled={isLoading} className={`w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-white bg-[#8DC63F] hover:bg-[#7AB929] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#8DC63F] ${isLoading ? 'opacity-70 cursor-not-allowed' : ''}`} data-id="element-544">
                {isLoading ? <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-545">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-546"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-547"></path>
                  </svg> : 'Anmelden'}
              </button>
            </div>
          </form>
        </div>
        <div className="mt-6 text-center" data-id="element-548">
          <p className="text-sm text-gray-500" data-id="element-549">
            Demo-Zugang: Benutzername "admin", Passwort "123"
          </p>
          <button onClick={() => setShowImpressum(true)} className="text-xs text-gray-500 hover:text-gray-700 mt-2" data-id="element-550">
            Impressum
          </button>
        </div>
      </div>
      {/* Impressum Modal */}
      {showImpressum && <Impressum onClose={() => setShowImpressum(false)} data-id="element-551" />}
    </div>;
}